import { $RootStore } from '../../src/stores/RootStore'

export function getImageBannerFileName(store: $RootStore, type: ImageSourceKey) {
  const { userStore: { data: { _id } } } = store
  return `saas/${getImageSourceKey(_id, type)}`
}

export function getImageBannerUrl(store: $RootStore, imageCacheTime: number, type: ImageSourceKey) {
  const { config: { imagesLocation } } = store
  const fileName = getImageBannerFileName(store, type)
  return `${imagesLocation}${fileName}?${imageCacheTime}`
}

export function getUrlWithoutCache(url: string) {
  return url.replace(/\?.*$/, '')
}

export const checkImageIsValid = async (url: string) => {
  try {
    const response = await fetch(url)
    if (response.ok) {
      return true
    } else {
      return false
    }
  } catch {
    return false
  }
}

type ImageSourceKey = 'banner-vertical' | 'banner-horizontal'

export function getImageSourceKey(_id: string, type: ImageSourceKey) {
  return `${_id}-${type}.jpg`
}

export function baseGetImageKitUrl({
  src,
  imageKitUrl,
  imagesLocation,
}: {
  src: string
  imageKitUrl: string
  imagesLocation: string
}) {
  let newSource = ''

  if (!src) return ''

  // Already an ImageKit URL
  if (src.includes(imageKitUrl)) return src

  newSource = src.replace(imagesLocation, '')

  return `${imageKitUrl}${newSource}`
}